<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="-not-fixed">
        <ion-title>
          <template v-if="addAppointment || addAppointmentOnly"
            >Termin hinzufügen</template
          >
          <template v-else>
            {{ doctor ? "Arzt bearbeiten" : "Arzt/Termin hinzufügen" }}
          </template>
        </ion-title>
        <ion-button slot="end" @click="modalController.dismiss()" fill="clear"
          ><ion-icon :icon="close"></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content">
      <ion-grid fixed class="ion-padding">
        <!-- <modal-close />
        <h6><b>Arzt hinzufügen</b></h6> -->
        <div class="ion-margin-top">
          <template v-if="addAppointment || addAppointmentOnly">
            <template v-if="doctor">
              <h2>
                <b v-if="doctor.Type === 'clinic'">{{ doctor.Clinicname }}</b>
                <b v-else
                  >{{ doctor.Surname }} {{ doctor.Firstname
                  }}{{ doctor.Title ? `, ${doctor.Title}` : "" }}</b
                >
              </h2>
              <div style="margin: 5px 0">
                <template v-if="doctor.Type === 'clinic'">
                  <div v-if="doctor.Clinicdivision">
                    Abteilung: {{ doctor.Clinicdivision }}
                  </div>
                  <div v-if="doctor.Firstname || doctor.Surname">
                    Behandelnder Arzt: {{ doctor.Title }}
                    {{ doctor.Firstname }} {{ doctor.Surname }}
                  </div>
                </template>
                <div v-if="doctor.Specialty">{{ doctor.Specialty }}</div>
                {{ doctor.Street }} {{ doctor.Housenumber }}<br />
                {{ doctor.Zip }} {{ doctor.City }}
              </div>
              <div>
                <a :href="'mailto:' + doctor.Email">{{ doctor.Email }}</a>
              </div>
              <div>
                <a :href="'tel:' + doctor.Phone">{{ doctor.Phone }}</a>
              </div>
            </template>
            <ion-row class="ion-margin-top">
              <ion-col size="12">
                <ion-item lines="none">
                  <ion-label position="stacked">Betreff</ion-label>
                  <ion-input
                    v-model="doctorData['AppointmentSubject']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="AppointmentSubject" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Datum (TT.MM.JJJJ)</ion-label>
                  <ion-input
                    type="date"
                    v-model="doctorData['Date']"
                  ></ion-input>
                </ion-item>
                <input-error id="Date" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Uhrzeit (HH:MM)</ion-label>
                  <ion-input
                    type="time"
                    v-model="doctorData['Time']"
                  ></ion-input>
                  <input-error id="Time" />
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-item lines="none">
                  <ion-label position="stacked">Notiz</ion-label>
                  <ion-textarea
                    rows="5"
                    v-model="doctorData['Reason']"
                  ></ion-textarea>
                </ion-item>
                <input-error id="Reason" />
              </ion-col>
            </ion-row>
            <div class="ion-text-center ion-margin-top">
              <ion-button @click="addDoctor()">Hinzufügen</ion-button>
            </div>
          </template>
          <template v-else>
            <!-- <template v-if="doctorData['Type'] === 'clinic'"> -->
            <div><b>Klinik</b> (Optional)</div>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked"
                    >Name/Bezeichnung Ordination/Klinik/Labor</ion-label
                  >
                  <ion-input
                    v-model="doctorData['Clinicname']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Clinicname" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Abteilung</ion-label>
                  <ion-input
                    v-model="doctorData['Clinicdivision']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Clinicdivision" />
              </ion-col>
            </ion-row>
            <div class="ion-margin-top ion-padding-top">
              <b>Behandelnder Arzt</b>
            </div>
            <!-- </template> -->
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Anrede</ion-label>
                  <ion-select
                    v-model="doctorData['Gender']"
                    placeholder="Frau/Herr"
                    cancel-text="Abbrechen"
                    interface="action-sheet"
                    :interfaceOptions="{ header: 'Anrede' }"
                  >
                    <ion-select-option>Frau</ion-select-option>
                    <ion-select-option>Herr</ion-select-option>
                  </ion-select>
                </ion-item>
                <input-error id="Gender" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Titel</ion-label>
                  <ion-input
                    v-model="doctorData['Title']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Title" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Vorname</ion-label>
                  <ion-input
                    v-model="doctorData['Firstname']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Firstname" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Nachname</ion-label>
                  <ion-input
                    v-model="doctorData['Surname']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Surname" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-item lines="none" style="overflow: visible; z-index: 2">
                  <ion-label position="stacked">Facharztrichtung</ion-label>
                  <ion-input
                    class="u-pointer-auto"
                    autocapitalize="on"
                    ref="specialtyInput"
                    id="specialtyInput"
                  />
                </ion-item>
                <input-error id="Specialty" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Telefon</ion-label>
                  <ion-input
                    placeholder="+49XXXXXXXXXX"
                    v-model="doctorData['Phone']"
                    type="tel"
                  ></ion-input>
                </ion-item>
                <input-error id="Phone" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">E-Mail</ion-label>
                  <ion-input
                    v-model="doctorData['Email']"
                    type="email"
                  ></ion-input>
                </ion-item>
                <input-error id="Email" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Nach Adresse suchen</ion-label>
                  <ion-row style="width: 100%" class="ion-align-items-center">
                    <ion-col size="auto">
                      <ion-icon
                        size="large"
                        :src="require('@lib/assets/icons/map_marker.svg')"
                      ></ion-icon>
                    </ion-col>
                    <ion-col class="ion-no-padding">
                      <ion-input ref="placeInput">
                        <!-- <GMapAutocomplete
                        class="c-input"
                        placeholder=""
                        @place_changed="setPlace"
                        :options="{
                          componentRestrictions: {
                            country: ['de'],
                          },
                        }"
                      >
                      </GMapAutocomplete> -->
                      </ion-input>
                    </ion-col>
                  </ion-row>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Straße</ion-label>
                  <ion-input
                    v-model="doctorData['Street']"
                    autocapitalize="on"
                  ></ion-input>
                </ion-item>
                <input-error id="Street" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Hausnummer/Tür</ion-label>
                  <ion-input v-model="doctorData['Housenumber']"></ion-input>
                </ion-item>
                <input-error id="Housenumber" />
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="6">
                <ion-item lines="none">
                  <ion-label position="stacked">PLZ</ion-label>
                  <ion-input
                    type="number"
                    v-model="doctorData['Zip']"
                  ></ion-input>
                </ion-item>
                <input-error id="Zip" />
              </ion-col>
              <ion-col>
                <ion-item lines="none">
                  <ion-label position="stacked">Stadt</ion-label>
                  <ion-input
                    v-model="doctorData['City']"
                    autocapitalize="on"
                  ></ion-input>
                  <input-error id="City" />
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-item lines="none">
                  <ion-label position="stacked">Notiz</ion-label>
                  <ion-textarea
                    rows="5"
                    v-model="doctorData['Reason']"
                  ></ion-textarea>
                </ion-item>
                <input-error id="Reason" />
              </ion-col>
            </ion-row>
            <template v-if="!doctor">
              <ion-item lines="none" class="ion-margin-top">
                <ion-checkbox
                  slot="start"
                  v-model="doctorData['IsUserAppointment']"
                >
                </ion-checkbox>
                <ion-label> Es handelt sich um einen Termin </ion-label>
              </ion-item>
              <ion-row v-if="doctorData['IsUserAppointment']">
                <ion-col size="12" size-md="6">
                  <ion-item lines="none">
                    <ion-label position="stacked">Datum (TT.MM.JJJJ)</ion-label>
                    <ion-input
                      type="date"
                      v-model="doctorData['Date']"
                    ></ion-input>
                  </ion-item>
                  <input-error id="Date" />
                </ion-col>
                <ion-col>
                  <ion-item lines="none">
                    <ion-label position="stacked">Uhrzeit (HH:MM)</ion-label>
                    <ion-input
                      type="time"
                      v-model="doctorData['Time']"
                    ></ion-input>
                    <input-error id="Time" />
                  </ion-item>
                </ion-col>
              </ion-row>
            </template>
            <div class="ion-text-center ion-margin-top">
              <template v-if="doctor">
                <ion-button class="ion-margin-top" @click="editDoctor()"
                  >Ändern</ion-button
                >
                <ion-button
                  class="ion-margin-top"
                  @click="openDeleteDoctorModal()"
                  >Löschen</ion-button
                >
              </template>
              <ion-button v-else class="ion-margin-top" @click="addDoctor()"
                >Hinzufügen</ion-button
              >
            </div>
          </template>
        </div>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  modalController,
  IonSelect,
  IonSelectOption,
  IonIcon,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonCheckbox,
  toastController,
  IonTextarea,
} from "@ionic/vue";
// import ModalClose from "@lib/components/ModalClose";
import InputError from "@/components/InputError";
import { onMounted, onUnmounted, ref, toRef } from "vue";
import { useStore } from "vuex";
import axios from "@/plugins/axios";
import { useRouter } from "vue-router";
import autoComplete from "@tarekraafat/autocomplete.js";
// import "https://cdn.jsdelivr.net/npm/@tarekraafat/autocomplete.js@10.2.7/dist/css/autoComplete.02.min.css";
import "@tarekraafat/autocomplete.js/dist/css/autoComplete.02.css";
import { close } from "ionicons/icons";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import AlertModal from "@/components/AlertModal";
import { apiDeleteDoctor } from "@/api/user";

export default {
  components: {
    IonPage,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInput,
    IonButton,
    // ModalClose,
    InputError,
    IonSelect,
    IonSelectOption,
    IonIcon,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonCheckbox,
    IonTextarea,
  },
  props: {
    doctor: {
      required: false,
      type: Object,
      default: null,
    },
    addAppointment: {
      default: false,
    },
    addAppointmentOnly: {
      default: false,
    },
  },
  setup(props) {
    const doctor = toRef(props, "doctor");
    const content = ref(null);
    const placeInput = ref(null);
    let placeInputElement = null;
    const specialtyInput = ref(null);
    let specialtyInputElement = null;
    if (Capacitor.isNativePlatform()) {
      if (Capacitor.getPlatform() === "ios") {
        Keyboard.addListener("keyboardDidShow", (info) => {
          console.log("keyboard did show", info);
          if (placeInputElement === document.activeElement) {
            setTimeout(() => {
              content.value?.$el.scrollByPoint(0, 150, 200);
            }, 500);
          }
        });
      } else if (Capacitor.getPlatform() === "android") {
        Keyboard.addListener("keyboardDidShow", (info) => {
          console.log("keyboard did show", info);
          if (specialtyInputElement === document.activeElement) {
            setTimeout(() => {
              content.value?.$el.scrollByPoint(0, 150, 200);
            }, 500);
          }
        });
      }
    }

    onUnmounted(() => {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios") {
        Keyboard.removeAllListeners();
      }
    });

    const store = useStore();
    const router = useRouter();

    const doctorData = ref({
      Type: "",
      Clinicname: "",
      Clinicdivision: "",
      Gender: "",
      Title: "",
      Firstname: "",
      Surname: "",
      // Specialty: "",
      Phone: "",
      Email: "",
      Street: "",
      Housenumber: "",
      Zip: "",
      Reason: "",
      City: "",
      CityLat: "",
      CityLng: "",
      IsCase: "0",

      From: "",
      Id: "",

      IsUserAppointment: false,
      IsUserAppointmentOnly: false,
      AppointmentSubject: "",
      Date: "",
      Time: "",
    });

    const setPlace = (event) => {
      console.log(event);
      console.log(event.geometry.location.lat());
      console.log(event.geometry.location.lng());
      if (event.address_components) {
        for (const addressComponent of event.address_components) {
          if (addressComponent.types.includes("route")) {
            doctorData.value.Street = addressComponent.long_name;
          } else if (addressComponent.types.includes("street_number")) {
            doctorData.value.Housenumber = addressComponent.short_name;
          } else if (addressComponent.types.includes("postal_code")) {
            doctorData.value.Zip = addressComponent.short_name;
          } else if (addressComponent.types.includes("locality")) {
            doctorData.value.City = addressComponent.long_name;
          }
        }
        doctorData.value.CityLat = event.geometry.location.lat();
        doctorData.value.CityLng = event.geometry.location.lng();
      }
    };

    onMounted(async () => {
      placeInputElement = await placeInput.value?.$el.getInputElement();
      const options = {
        componentRestrictions: {
          country: ["de"],
        },
      };
      if (placeInputElement) {
        // eslint-disable-next-line
        const place = new google.maps.places.Autocomplete(
          placeInputElement,
          options
        );
        place.addListener("place_changed", () => {
          setPlace(place.getPlace());
        });
      }

      specialtyInputElement = await specialtyInput.value?.$el.getInputElement();
      specialtyInputElement?.setAttribute("id", "Specialty");

      if (doctor.value) {
        doctorData.value = {
          ...doctorData.value,
          ...doctor.value,
          Id: doctor.value.Index,
        };
        if (props.addAppointment) {
          doctorData.value = {
            ...doctorData.value,
            IsUserAppointment: true,
            AppointmentSubject: "",
            Date: "",
            Time: "",
            Reason: "",
          };
        }
        if (specialtyInputElement) {
          specialtyInputElement.value = doctor.value.Specialty;
        }
      } else if (props.addAppointmentOnly) {
        doctorData.value = {
          IsUserAppointment: true,
          IsUserAppointmentOnly: true,
          Date: "",
          Time: "",
          Reason: "",
        };
      }

      if (specialtyInputElement) {
        const autoCompleteJS = new autoComplete({
          selector: "#Specialty",
          placeHolder: "",
          data: {
            src: [
              "Allgemeinchirurg",
              "Allgemeiner Arzt",
              "Allgemeinmediziner",
              "Angiologe",
              "Anästhesist",
              "Arbeitsmediziner",
              "Augenarzt",
              "Bluthochdruckfacharzt",
              "Chirurg",
              "Dermathologe",
              "Diabetologe",
              "Diabetologie",
              "Endokrinologe",
              "Frauenarzt",
              "Gastroenterologe",
              "Gefäßchirurg",
              "Gefäßfacharzt",
              "Gesichtschirurg",
              "Gynäkologe",
              "HNO Arzt",
              "Hals-Nasen-Ohrenarzt",
              "Hausarzt",
              "Hautarzt",
              "Herz-Kreislauf Facharzt",
              "Herzchirurg",
              "Hormonarzt",
              "Humangenetiker",
              "Hämatologe",
              "Internist",
              "Jugendpsychiater",
              "Jugendpsychotherapeut",
              "Jungendarzt",
              "Kardiologe",
              "Kardiologie",
              "Kardiovaskularchirurgie",
              "Kieferchirurg",
              "Kieferorthopäde",
              "Kinder- und Jugendpsychiatrie",
              "Kinder- und Jugendpsychotherapie",
              "Kinderarzt",
              "Kinderchirurg",
              "Kinderkardiologe",
              "Kinderkardiologie",
              "Kinderpsychiater",
              "Kinderpsychotherapeut",
              "Kinderradiologe",
              "Krebsfacharzt",
              "Lungenarzt",
              "Lungenfacharzt",
              "Magen-Darm Facharzt",
              "Mund-Kiefer-Gesichtschirurgie",
              "Mundchirurg",
              "Nephrologe",
              "Nervenfacharzt",
              "Neurochirurg",
              "Neurochirurgie",
              "Neurologe",
              "Neurologie",
              "Neuropathologe",
              "Neuropädiater",
              "Neuropädiatrie",
              "Neuroradiologe",
              "Nierenfacharzt",
              "Onkologe",
              "Orthopäde",
              "Pathologe",
              "Pharmakologe",
              "Physikalischer Mediziner",
              "Physiologe",
              "Physiologie",
              "Plastischer Chirurg",
              "Pneumologe",
              "Praktischer Arzt",
              "Psychiater",
              "Psychiatrie",
              "Psychologe",
              "Psychosomatische Medizin",
              "Psychosomatischer Mediziner",
              "Psychotherapeut",
              "Psychotherapie",
              "Pulmologe",
              "Radiologe",
              "Rechtsmediziener",
              "Reha Arzt",
              "Rehabilitativer Mediziner",
              "Rheumatologe",
              "Schönheitschirurg",
              "Strahlentherapeut",
              "Toraxchirurg",
              "Toxikologe",
              "Transfusionsmediziner",
              "Unfallchirurg",
              "Urologe",
              "Viszeralchirurg",
              "Zahnarzt",
              "Zahnmediziner",
            ],
          },
          resultItem: {
            highlight: true,
          },
          events: {
            input: {
              selection: (event) => {
                console.log(event);
                const selection = event.detail.selection.value;
                console.log(specialtyInput);
                specialtyInputElement.value = selection;
                // doctorData.value.Specialty = selection;
              },
            },
          },
        });
      }
    });

    const addDoctor = async () => {
      if (doctorData.value.Clinicname || doctorData.value.Clinicdivision) {
        doctorData.value.Type = "clinic";
      } else {
        doctorData.value.Type = "doctor";
      }
      store.commit("setShowLoading", true);
      const data = {
        ...doctorData.value,
        Specialty: specialtyInputElement?.value || doctorData.value.Specialty,
      };
      const response = await axios.post(
        "?Mode=General&Function=SaveDoctor",
        data
      );
      if (response.data.Status === "Success") {
        if (doctorData.value.IsUserAppointment) {
          const toast = await toastController.create({
            message: "Sie erhalten einen Tag vor dem Termin eine Erinnerung.",
            duration: 5000,
          });
          toast.present();
        }
        modalController.dismiss({ isEdited: true });
        if (doctorData.value.IsUserAppointment) {
          router.push({
            name: "termine-aerzte",
            query: { tab: "appointments" },
          });
        } else {
          router.push({
            name: "termine-aerzte",
            query: { tab: "doctors" },
          });
        }
      }
    };

    const editDoctor = async () => {
      if (doctorData.value.Clinicname || doctorData.value.Clinicdivision) {
        doctorData.value.Type = "clinic";
      } else {
        doctorData.value.Type = "doctor";
      }
      store.commit("setShowLoading", true);
      const data = {
        ...doctorData.value,
        Specialty: specialtyInputElement.value,
      };
      const response = await axios.post(
        "?Mode=General&Function=EditDoctor",
        data
      );
      if (response.data.Status === "Success") {
        modalController.dismiss({ isEdited: true });
      }
    };

    const deleteDoctor = async () => {
      store.commit("setShowLoading", true);
      const data = {
        ...doctorData.value,
        Specialty: specialtyInputElement.value,
      };
      const response = await apiDeleteDoctor(data);
      if (response.data.Status === "Success") {
        modalController.dismiss({ isEdited: true });
      }
    };
    const openDeleteDoctorModal = async () => {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: "Möchten Sie den Arzt wirklich löschen?",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          deleteDoctor();
        }
      });
      return modal.present();
    };

    return {
      doctorData,
      setPlace,
      addDoctor,
      editDoctor,
      openDeleteDoctorModal,
      close,
      modalController,
      specialtyInput,
      placeInput,
      content,
    };
  },
};
</script>

<style lang="scss">
.autoComplete_wrapper {
  width: 100%;
}
.autoComplete_wrapper > ul > li mark {
  color: var(--ion-color-primary);
}
</style>
